export default __webpack_public_path__ + "static/media/pagetwo.701c7f49.txt";